import { FilterMatchMode } from "primereact/api"

export class Etiqueta {

    model = {
        id: {value: null, export: false},
        idp: {value: null, export: false},
        origen: {value: null, export: false},
        etiqueta: {value: '', export: true, header: 'Etiqueta', required: 'Etiqueta es requerido', maxLength: 'Máximo 250 caracteres', minLength: 'Mínimo 3 caracteres',
            max: 400, min: 4, filterField: 'etiqueta', table: true, filter: true, sort: true, filterPlaceholder: 'Buscar por etiqueta.', matchMode: FilterMatchMode.CONTAINS},
        sigla: {value: '', export: true, header: 'Sigla', required: false, maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 3 caracteres', max: 300, min: 4, filterField: 'sigla', filter: false, sort: true, table: true},
        tipo_negocio: {header: 'Área de negocio', value: [], required: 'Seleccione una opción', optionLabel: 'nombre', export: false, table: true},
    }

    optionLabel = 'nombre'
}
